module.exports = __webpack_public_path__ + "img/go8.10749dfa.png";